// @core/api/endpoints/authn/refresh_tokens.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RefreshTokensRequest,
  SignInResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Refresh access and refresh tokens
 * Exchanges a valid refresh token for a new access and refresh token pair. Used to maintain user sessions without requiring re-authentication.
 * @public This endpoint does not require authentication
 */
export async function RefreshTokens(
  data: RefreshTokensRequest,
  options?: RequestOptions
): Promise<SignInResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/tokens/refresh`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<SignInResponse>(requestPath, data, requestOptions);
}
